import React from "react";
import { withStyles } from "@material-ui/core";
import { inject, observer } from "mobx-react";
import { compose } from "recompose";
import { withUserProfile } from "../../../../userProfile/userProfileContext";
import { getDataWithQueryString } from "../../../../api/componentAPIs";
import AppConstants from "../../../../appConstants";
import { mapKeys, pickBy } from "lodash/object";
import Events from "../../../../utilities/EventEmitter";

const styles = (theme) => ({
  kpiContainer: {
    height: "100%",
    width: "100%",
    display: "flex",
  },
  kpiHeader: {
    display: "flex",
    fontSize: "16px",
    width: "60px",
    height: "100%",
    textAlign: "center",
    color: theme.HeaderSelectedText,
    fontWeight: 600,
    alignItems: "center",
    justifyContent: "center",
  },
  kpiPin: {
    display: "table-cell",
    fontSize: "16px",
    width: "60px",
    height: "100%",
    verticalAlign: "middle",
    textAlign: "center",
  },
  kpiContent: {
    display: "flex",
    height: "100%",
    width: "calc(100% - 60px)",
    alignItems: "center",
    overflow: "auto",
    whiteSpace: "nowrap",
  },
  kpiValueContainer: {
    display: "inline-block",
    paddingLeft: "25px",
    paddingRight: "25px",
  },
  kpiName: {
    fontSize: "14px",
    color: theme.KPI.KPILabel,
  },
  kpiValue: {
    fontSize: "16px",
    fontWeight: "bold",
    textAlign: "center",
    color: theme.KPI.KPISingleValue,
  },
  kpiGoal: {
    color: theme.KPI.KPIGoalValue,
  },
  kpiValueNormal: {
    color: theme.KPI.KPISingleValue,
  },
  kpiValuePositive: {
    color: theme.KPI.KPIPositive,
  },
  kpiValueNegative: {
    color: theme.KPI.KPINegative,
  },
});
class KPIPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      kpiData: null,
    };
    this.terminalCode = this.props.userData.userProfile.terminal.code;
  }
  componentDidMount() {
    this._isComponentMounted = true;
    Events.on("getComplianceKPI",this.getDockComplianceKPIs)
  }
  componentWillUnmount() {
    this._isComponentMounted = false;
    Events.off("getComplianceKPI",this.getDockComplianceKPIs)
  }

  getDockComplianceKPIs = (planDate,terminalCode) => {
    getDataWithQueryString(
      "GetDockComplianceKPIs",
      `planDate=${planDate}&terminalCode=${terminalCode}`
    ).then((response) => {
      if (this._isComponentMounted) {
        if (response.status === 200) {
          const mappedResponse = pickBy(
            mapKeys(response.data, (v, k) => AppConstants.DCR_KPI_Mapping[k]),
            (v, k) => k !== 'undefined'
          );
          this.setState({
            kpiData: mappedResponse,
          });
        }
      }
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.kpiContainer}>
        <div className={classes.kpiHeader}>KPI</div>
        <div className={`${classes.kpiContent} KPIContent`}>
          {this.state?.kpiData &&
            Object.entries(this.state.kpiData).map((kpiArray, index) => (
              <div className={classes.kpiValueContainer} key={index}>
                <div
                  className={`${classes.kpiValue} ${classes.kpiValueNormal}`}
                >
                  {kpiArray[1]}
                </div>
                <div className={classes.kpiName}>{kpiArray[0]}</div>
              </div>
            ))}
        </div>
        {/* TODO: Expand and Collapse behavior */}
        {/* <div className={`${classes.kpiPin} icon-icon_cancel-58`}></div> */}
      </div>
    );
  }
}

export default compose(
  withStyles(styles),
  withUserProfile,
  inject("IBPlanningStore")
)(observer(KPIPanel));
